export const TITLE_LINE_HEIGHT = 1.55;

export const bodyFontSize = (mobile?: boolean) => {
  return mobile ? 16 : 18;
};

export const highlightedBodyFontSize = (mobile?: boolean) => {
  return mobile ? 18 : 20;
};

export const headlineFontSize = (mobile?: boolean) => {
  return mobile ? 26 : 38;
};

export const mediumFontSize = (mobile?: boolean) => {
  return mobile ? 20 : 26;
};

export const knownFromList = [
  { src: '/images/press-logos/der_spiegel.png', alt: 'Der Spiegel' },
  { src: '/images/press-logos/die_welt.png', alt: 'Die Welt' },
  { src: '/images/press-logos/handelsblatt.png', alt: 'Handelsblatt' },
  { src: '/images/press-logos/swr.png', alt: 'SWR' },
];
